import Main from './Main'
import Lista from './components/Grupos'
import Novo from './components/NovoGrupo'

export default [
  {
    path: 'grupos-permissao',
    name: 'config.grupos',
    component: Main,
    redirect: { name: 'config.grupos.list' },
    children: [
      {
        path: '/',
        name: 'config.grupos.list',
        component: Lista
      },
      {
        path: 'registro',
        name: 'config.grupos.novo',
        component: Novo
      },
      {
        path: ':id',
        name: 'config.grupos.edit',
        component: Novo
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/app/configuracoes/grupos-permissao/routes.js